import common from '../common';
import Scene from './Scene';

export default class HelpScene extends Scene {
	constructor() {
		super();

		this.normalLine = null;
		this.lineMask = null;
		this.tutorialPencil = null;
		this.resumeButton = null;
		this.homeButton = null;
	}

	init() {
		super.init();

		let fade = new PIXI.Graphics();
		fade.beginFill(0x0, 0.5);
		fade.drawRect(0, 0, common.STAGE_WIDTH, common.STAGE_HEIGHT);
		fade.endFill();
		this.addChild(fade);
		fade.interactive = true;

		let notebook = new PIXI.Sprite(P3.assets.texture('pause_panel'));
		notebook.anchor.set(0.5, 0);
		notebook.position.set(common.STAGE_WIDTH * 0.5, 50);
		this.addChild(notebook);

		let states = new P3.ButtonStates();
		states.normal = P3.assets.texture('btn_pri_large_out');
		states.over = P3.assets.texture('btn_pri_large_over');
		states.down = P3.assets.texture('btn_pri_large_down');
		states.icon = P3.assets.texture('icon_pri_large_out');

		this.resumeButton = new P3.Button(states);
		this.resumeButton.signals.click.add(this.onPlayButtonClick, this);
		this.resumeButton.position.set(common.STAGE_WIDTH * 0.5 + 100, common.STAGE_HEIGHT * 0.5);
		this.addChild(this.resumeButton);

		states = new P3.ButtonStates();
		states.normal = P3.assets.texture('btn_pri_large_out');
		states.over = P3.assets.texture('btn_pri_large_over');
		states.down = P3.assets.texture('btn_pri_large_down');
		states.icon = P3.assets.texture('icon_pri_home_out');

		this.homeButton = new P3.Button(states);
		this.homeButton.signals.click.add(this.onHomeButtonClick, this);
		this.homeButton.position.set(common.STAGE_WIDTH * 0.5 - 100, common.STAGE_HEIGHT * 0.5);
		this.addChild(this.homeButton);

		states = new P3.ButtonStates();
		states.normal = P3.assets.texture('btn_pri_small_out');
		states.over = P3.assets.texture('btn_pri_small_over');
		states.down = P3.assets.texture('btn_pri_small_down');
		states.icon = P3.assets.texture('icon_pri_sound_out');
		states.iconAlt = P3.assets.texture('icon_pri_mute_out');

		this.muteButton = new P3.MuteButton(states);
		this.addChild(this.muteButton);
	}

	resize() {
		super.resize();
		this.muteButton.position.set((common.STAGE_WIDTH + P3.View.width) * 0.5 - 100, 100);
	}

	update() {
		super.update();
	}

	onHomeButtonClick() {
		this.signals.home.dispatch(this);
	}

	onPlayButtonClick() {
		this.signals.next.dispatch(this);
	}
}